var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"app":"","color":_vm.webTheme.colors.primary.hexa,"value":_vm.$t(_vm.snackbar),"top":""}},[_vm._v(" "+_vm._s(_vm.$t(_vm.snackbar))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }